import { isFunction as _isFunction } from 'lodash'

import moment from 'moment'


const formatDate = (date, duration) => {

  const momentDate = moment(date).format("LLLL")

  return `${momentDate} ${duration}`
}

export { formatDate } // eslint-disable-line import/prefer-default-export
